"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var Localize_1 = require("../../gen-src/Localize");
var FeatureFlagsContext_1 = require("../featureFlags/FeatureFlagsContext");
var DataCatalogProvider_1 = require("../wrappers/DataCatalogProvider");
var DataQualityDetail_1 = require("./DataQualityDetail");
var DataQualityDetailPanel_1 = require("./DataQualityDetailPanel");
var DataQualityType_1 = require("./DataQualityType");
var DataQualityStatusChipId = 'data-quality-status-chip-id';
function EmbeddableDataQualityStatusChip(props) {
    return (React.createElement(DataCatalogProvider_1.FeatureFlagsProvider, { featureFlags: props.featureFlags },
        React.createElement(DataCatalogProvider_1.SiteUrlsProvider, { siteUrls: props.siteUrls },
            React.createElement(DataQualityStatusChip, __assign({}, props)))));
}
exports.EmbeddableDataQualityStatusChip = EmbeddableDataQualityStatusChip;
var DataQualityStatusChip = /** @class */ (function (_super) {
    __extends(DataQualityStatusChip, _super);
    function DataQualityStatusChip(props) {
        var _this = _super.call(this, props) || this;
        _this.setIsDialogOpen = function (isDialogOpen) {
            _this.setState({ isDialogOpen: isDialogOpen });
        };
        _this.ref = React.createRef();
        _this.setRef = function (button) {
            if (!!button) {
                _this.setState({ iconOnlyButtonRef: ReactDOM.findDOMNode(button) });
            }
        };
        _this.state = {
            isDialogOpen: false
        };
        return _this;
    }
    DataQualityStatusChip.prototype.render = function () {
        var _this = this;
        if (!this.props || this.props.details.length < 1) {
            return null;
        }
        return (React.createElement(FeatureFlagsContext_1.FeatureFlagsContext.Consumer, null, function (featureFlags) {
            var isSevere = featureFlags.catalogSevereWarningsEnabled ? _this.props.details.some(function (d) { return d.isSevere; }) : false;
            var text = dataQualityTooltipTitle(_this.props);
            var baseProps = { text: text, isSevere: isSevere, testId: DataQualityStatusChipId };
            return (React.createElement(React.Fragment, null,
                _this.props.iconOnly ?
                    React.createElement(DataQualityDetail_1.DataQualityTooltipButton, __assign({}, baseProps, { kind: 'interactive-icon', setRef: _this.setRef, onClick: function () { return _this.setIsDialogOpen(!_this.state.isDialogOpen); } })) :
                    React.createElement(DataQualityDetail_1.DataQualityTooltipButton, __assign({}, baseProps, { kind: 'interactive-inline', ref: _this.ref, onClick: function () { return _this.setIsDialogOpen(!_this.state.isDialogOpen); } })),
                _this.state.isDialogOpen ? React.createElement(DataQualityDetailPanel_1.DataQualityDetailPanel, __assign({}, _this.props, { title: text, anchorEl: _this.props.iconOnly
                        ? (_this.state.iconOnlyButtonRef || undefined)
                        : _this.ref.current, side: _this.props.side || 'right', onCloseRequest: function () { return _this.setState({ isDialogOpen: false }); } })) : null));
        }));
    };
    return DataQualityStatusChip;
}(React.Component));
exports.DataQualityStatusChip = DataQualityStatusChip;
function dataQualityTooltipTitle(props) {
    if (!props || props.details.length < 1) {
        return '';
    }
    var count = props.details.length;
    if (count === 1) {
        return DataQualityType_1.localizeDataQualityTypeName(props.details[0].type);
    }
    return Localize_1.Messages.DataQualityIconMessage({
        MESSAGE_COUNT: count,
        MESSAGE_COUNT_LOC: Localize_1.Formatters.formatCount(count)
    });
}
//# sourceMappingURL=DataQualityStatusChip.js.map